module.exports = __webpack_public_path__ + "static/media/severino_pinholster_soash_hodgens_kayian.f0de72ed.gif";